import { j as e } from "../../../../../../jsx-runtime.BREq8dyb.js";
import { faInfoCircle as a } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as c } from "@fortawesome/react-fontawesome";
import { FormControl as m, Checkbox as x, Box as i, Tooltip as p } from "@mui/joy";
import { memo as d } from "react";
const b = d(({
  autofix: s,
  disabled: r = !1,
  setAutofix: t,
  numFixedCellsTotal: o
}) => {
  const n = {
    label: {
      "data-testid": "autofix-switch",
      sx: {
        cursor: "pointer",
        userSelect: "none",
        zIndex: 1
      }
    }
  };
  return /* @__PURE__ */ e.jsx(m, { disabled: r, children: /* @__PURE__ */ e.jsx(x, { checked: s, label: /* @__PURE__ */ e.jsxs(i, { sx: {
    alignItems: "baseline",
    display: "flex",
    flex: 1,
    gap: "0.5rem",
    justifyContent: "space-between"
  }, children: [
    /* @__PURE__ */ e.jsxs("span", { children: [
      "Fix failed values",
      /* @__PURE__ */ e.jsxs("span", { style: {
        lineHeight: 1,
        verticalAlign: "middle",
        whiteSpace: "nowrap"
      }, children: [
        " ",
        /* @__PURE__ */ e.jsx(p, { title: "This will attempt to fix invalid values based on column requirements. This includes for example converting emails to lowercase and removing invalid spaces from strings.", children: /* @__PURE__ */ e.jsx(c, { icon: a }) })
      ] })
    ] }),
    s ? /* @__PURE__ */ e.jsxs(i, { sx: {
      color: o > 0 ? "neutral.500" : "inherit",
      fontSize: "0.875rem",
      fontWeight: o > 0 ? 500 : 400
    }, children: [
      o > 0 ? o : "No",
      " value",
      o !== 1 ? "s" : "",
      " fixed"
    ] }) : null
  ] }), onChange: (l) => {
    t(l.target.checked);
  }, slotProps: n }) });
});
export {
  b as default
};
//# sourceMappingURL=FixFailedValuesCheckbox.js.map
